// LanguageSwitcher.jsx
import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledLanguageSwitcher = styled.div.attrs({
  className: "u-w100 u-row u-gap4 u-text-blue",
})`
  display: flex;
  color: var(--soremo-blue)

  justify-content: flex-end;
  cursor: pointer;

  transition: 0.3s;

  @media (width > 640px) {
    &:hover {
      color: var(--soremo-deep-blue);

      .material-symbols-rounded {
        color: var(--soremo-deep-blue);
        scale: 1.2;
      }
    }
  }
`;

const LanguageSwitcher = ({ language: controlledLanguage, onLanguageChange }) => {
  // language prop 指定時は制御モード（親の状態に追随）。未指定なら従来どおり内部状態。
  const [internalLanguage, setInternalLanguage] = useState("JP");
  const language = controlledLanguage ?? internalLanguage;

  const toggleLanguage = () => {
    const newLanguage = language === "JP" ? "EN" : "JP";
    setInternalLanguage(newLanguage);
    onLanguageChange(newLanguage);
  };

  return (
    <StyledLanguageSwitcher onClick={toggleLanguage}>
      <div className="u-col-center">
        <div className="material-symbols-rounded u-text-blue">language</div>
        <span className="bodytext-11 u-text-blue">
          {language === "JP" ? "EN" : "JP"}
        </span>
      </div>
    </StyledLanguageSwitcher>
  );
};

LanguageSwitcher.propTypes = {
  /** 指定時は制御モード。表示言語を親から渡す（"JP" | "EN"） */
  language: PropTypes.oneOf(["JP", "EN"]),
  onLanguageChange: PropTypes.func.isRequired,
};

export default LanguageSwitcher;
